__turbopack_context__.v({
  "card": "EmptyState-module-scss-module__g8dGna__card",
  "description": "EmptyState-module-scss-module__g8dGna__description",
  "title": "EmptyState-module-scss-module__g8dGna__title",
  "wrapper": "EmptyState-module-scss-module__g8dGna__wrapper",
});
